import { useEffect, useState } from 'react';

type StepsProps = {
  index: number;
  currentStep: number;
  onClick: (step: number) => void;
};
type StepperProps = {
  stepNumber: number;
  process: string[];
  onStepChange?: (step: number) => void;
};
export const Stepper = (props: StepperProps) => {
  const [currentStep, setCurrentStep] = useState(props.stepNumber);
  useEffect(() => {
    setCurrentStep(props.stepNumber);
  }, [props.stepNumber]);
  const handleClick = (step: number) => {
    if (step > currentStep) return;
    if (props.onStepChange) {
      props.onStepChange(step);
    }
    setCurrentStep(step);
  };
  return (
    <div className="stepper flex w-full  flex-col gap-3">
      <p className="text-muted">
        Step {currentStep}/{props.process.length}
      </p>
      <div className="flex min-w-full cursor-pointer justify-between gap-6">
        {props.process.map((_step, index) => (
          <Steps
            key={index}
            index={index}
            currentStep={currentStep}
            onClick={handleClick}
          />
        ))}
      </div>
    </div>
  );
};
export const Steps: React.FC<StepsProps> = ({
  index,
  currentStep,
  onClick,
}) => {
  return (
    <div
      onClick={() => onClick(index + 1)}
      className={`h-1 min-w-16 rounded-xl sm:min-w-24  ${
        index + 1 < currentStep ? ' bg-motitoBlue' : 'bg-gray-200'
      }`}
    >
      <span
        className={`rounded-xl bg-motitoBlue ${index + 1 === currentStep ? 'active block' : 'hidden'}`}
      />
    </div>
  );
};
